// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.photo-button {
  background-color: white; /* Цвет круга кнопки */
  border: none; /* Убираем границу кнопки */
  border-radius: 50%; /* Делаем кнопку круглой */
  width: 70px; /* Задаем ширину кнопки */
  height: 70px; /* Задаем высоту кнопки */
  cursor: pointer; /* Делаем курсор указывающим */
  display: flex; /* Устанавливаем flex display для центрирования содержимого */
  justify-content: center; /* Центрируем содержимое по горизонтали */
  align-items: center; /* Центрируем содержимое по вертикали */
  font-size: 18px; /* Задаем размер шрифта */
  color: black; /* Цвет текста кнопки */
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75); /* Добавляем тень */
  transition: background-color 0.3s ease; /* Добавляем плавное изменение цвета при наведении */
}
.photo-button img {
  width: 71px;
  height: 71px;
}
.photo-button.restart {
  width: 50px; /* Задаем ширину кнопки */
  height: 50px;
  position: absolute;
  bottom: -25px;
  left: calc(50% + 60px);
}
.photo-button.restart img {
  width: 40px;
  height: 40px;
}
.photo-button.camera {
  width: 50px; /* Задаем ширину кнопки */
  height: 50px;
  position: absolute;
  bottom: -25px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  background-color: rgba(86, 125, 184, 0.7490196078);
  left: calc(50% + 80px);
  z-index: 100;
}
.photo-button.camera img {
  width: 30px;
  height: 30px;
}

.cameraIcon {
  width: 50px; /* Задаем ширину кнопки */
  height: 50px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  background-color: rgba(86, 125, 184, 0.7490196078);
  border-radius: 50%;
}
.cameraIcon img {
  width: 30px;
  height: 30px;
}

.camera_btn_container {
  width: 100%;
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: -25px;
}

.photo-button:hover {
  background-color: lightgray; /* Изменяем цвет круга при наведении */
}

.photo-button:focus {
  outline: none; /* Убираем рамку фокуса */
}

.slides {
  background: white;
  position: relative;
  transition: transform 0.5s ease;
  overflow: hidden;
}

.slide {
  position: absolute;
  flex: 0 0 100%;
  opacity: 0;
  overflow: hidden;
}

.slide img {
  object-fit: cover;
  width: 100%;
  height: auto;
}

.active {
  opacity: 1;
}

.stepButtons {
  position: absolute;
  top: 100px;
  width: calc(100% + 100px);
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  left: -50px;
  z-index: 100;
}`, "",{"version":3,"sources":["webpack://./src/Components/SamplesImages/src/camera.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,uBAAA,EAAA,sBAAA;EACA,YAAA,EAAA,2BAAA;EACA,kBAAA,EAAA,0BAAA;EACA,WAAA,EAAA,yBAAA;EACA,YAAA,EAAA,yBAAA;EACA,eAAA,EAAA,8BAAA;EACA,aAAA,EAAA,6DAAA;EACA,uBAAA,EAAA,yCAAA;EACA,mBAAA,EAAA,uCAAA;EACA,eAAA,EAAA,yBAAA;EACA,YAAA,EAAA,uBAAA;EACA,+CAAA,EAAA,mBAAA;EACA,sCAAA,EAAA,oDAAA;AAEF;AADE;EACE,WAAA;EACA,YAAA;AAGJ;AADE;EACE,WAAA,EAAA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EAEA,sBAAA;AAEJ;AAAI;EACE,WAAA;EACA,YAAA;AAEN;AACE;EACE,WAAA,EAAA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,+CAAA;EACA,kDAAA;EAEA,sBAAA;EACA,YAAA;AAAJ;AACI;EACE,WAAA;EACA,YAAA;AACN;;AAIA;EACE,WAAA,EAAA,yBAAA;EACA,YAAA;EACA,+CAAA;EACA,kDAAA;EACA,kBAAA;AADF;AAEE;EACE,WAAA;EACA,YAAA;AAAJ;;AAGA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;AAAF;;AAEA;EACE,2BAAA,EAAA,sCAAA;AACF;;AAEA;EACE,aAAA,EAAA,yBAAA;AACF;;AAkBA;EACE,iBAAA;EACA,kBAAA;EACA,+BAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,kBAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;AAfF;;AAiBA;EACE,UAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AAdF","sourcesContent":[".photo-button {\n  background-color: white; /* Цвет круга кнопки */\n  border: none; /* Убираем границу кнопки */\n  border-radius: 50%; /* Делаем кнопку круглой */\n  width: 70px; /* Задаем ширину кнопки */\n  height: 70px; /* Задаем высоту кнопки */\n  cursor: pointer; /* Делаем курсор указывающим */\n  display: flex; /* Устанавливаем flex display для центрирования содержимого */\n  justify-content: center; /* Центрируем содержимое по горизонтали */\n  align-items: center; /* Центрируем содержимое по вертикали */\n  font-size: 18px; /* Задаем размер шрифта */\n  color: black; /* Цвет текста кнопки */\n  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75); /* Добавляем тень */\n  transition: background-color 0.3s ease; /* Добавляем плавное изменение цвета при наведении */\n  img {\n    width: 71px;\n    height: 71px;\n  }\n  &.restart {\n    width: 50px; /* Задаем ширину кнопки */\n    height: 50px;\n    position: absolute;\n    bottom: -25px;\n    // right: 25px;\n    left: calc(50% + 60px);\n\n    img {\n      width: 40px;\n      height: 40px;\n    }\n  }\n  &.camera {\n    width: 50px; /* Задаем ширину кнопки */\n    height: 50px;\n    position: absolute;\n    bottom: -25px;\n    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);\n    background-color: #567db8bf;\n    // right: 25px;\n    left: calc(50% + 80px);\n    z-index: 100;\n    img {\n      width: 30px;\n      height: 30px;\n    }\n  }\n}\n\n.cameraIcon {\n  width: 50px; /* Задаем ширину кнопки */\n  height: 50px;\n  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);\n  background-color: #567db8bf;\n  border-radius: 50%;\n  img {\n    width: 30px;\n    height: 30px;\n  }\n}\n.camera_btn_container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  position: absolute;\n  bottom: -25px;\n}\n.photo-button:hover {\n  background-color: lightgray; /* Изменяем цвет круга при наведении */\n}\n\n.photo-button:focus {\n  outline: none; /* Убираем рамку фокуса */\n}\n\n//   .photo-restart_btn {\n//     background-color: white; /* Цвет круга кнопки */\n//     border: none; /* Убираем границу кнопки */\n//     border-radius: 50%; /* Делаем кнопку круглой */\n//     width: 50px; /* Задаем ширину кнопки */\n//     height: 50px; /* Задаем высоту кнопки */\n//     cursor: pointer; /* Делаем курсор указывающим */\n//     display: flex; /* Устанавливаем flex display для центрирования содержимого */\n//     justify-content: center; /* Центрируем содержимое по горизонтали */\n//     align-items: center; /* Центрируем содержимое по вертикали */\n//     font-size: 18px; /* Задаем размер шрифта */\n//     color: black; /* Цвет текста кнопки */\n//     box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75); /* Добавляем тень */\n//     transition: background-color 0.3s ease; /* Добавляем плавное изменение цвета при наведении */\n//   }\n\n.slides {\n  background: white;\n  position: relative;\n  transition: transform 0.5s ease;\n  overflow: hidden;\n}\n\n.slide {\n  position: absolute;\n  flex: 0 0 100%;\n  opacity: 0;\n  overflow: hidden;\n}\n\n.slide img {\n  object-fit: cover;\n  width: 100%;\n  height: auto;\n}\n.active {\n  opacity: 1;\n}\n\n.stepButtons {\n  position: absolute;\n  top: 100px;\n  width: calc(100% + 100px);\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  left: -50px;\n  z-index: 100;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
